/**
 * Models the chart reviews bulk edit screen
 */

import Brace from "backbone.brace";

const BulkEditForm = Brace.Model.extend({
  namedAttributes: {
    chartStatus: String,
    projectId: String,
    retrievalStatus: String,
    retrievalStatusNAReason: String,
    reviewers: [Number],
    keepExistingReviewers: Boolean,
  },

  defaults: {
    chartStatus: null,
    projectId: null,
    retrievalStatus: null,
    retrievalStatusNAReason: null,
    reviewers: null,
    keepExistingReviewers: null,
  },

  validate(attrs) {
    let filledFields = 0;

    if (!_.isEmpty(attrs.chartStatus)) {
      filledFields++;
    } else {
      this.setChartStatus(null);
    }

    if (!_.isEmpty(attrs.projectId)) {
      filledFields++;
    } else {
      this.setProjectId(null);
    }

    if (!_.isEmpty(attrs.retrievalStatus)) {
      filledFields++;

      // retrieval status reason is required when status is NA
      if (attrs.retrievalStatus === "NOT_AVAILABLE") {
        if (!_.isEmpty(attrs.retrievalStatusNAReason)) {
          filledFields++;
        } else {
          return "You must select a reason for your choice of retrieval status.";
        }
      } else {
        this.setRetrievalStatusNAReason(null);
      }
    } else {
      this.setRetrievalStatus(null);
    }

    if (Array.isArray(attrs.reviewers) && attrs.reviewers.length) {
      filledFields++;
      // set replace reviewers flag to false when not checked
      if (!attrs.keepExistingReviewers) {
        this.setKeepExistingReviewers(false);
      }
    } else {
      this.setReviewers(null);
      this.setKeepExistingReviewers(null);
    }

    if (0 === filledFields) {
      return "You must change at least one of the chart properties.";
    }
  },
});

export { BulkEditForm as default };
